import { createRouter, createWebHistory } from 'vue-router'

// Layouts
import DefaultLayout from '../layouts/DefaultLayout.vue'
import AuthLayout from '../layouts/AuthLayout.vue'

// Views
import Dashboard from '../views/Dashboard.vue'
import Auth from '../views/Auth.vue'
import PasswordChange from '../views/PasswordChange.vue'
import PasswordReset from '../views/PasswordReset.vue'
import Statistics from '../views/Statistics.vue'

const routes = [
  { 
    path: '/', 
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/Dashboard'
      },
      {
        path: 'Dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: 'Statistics',
        name: 'Statistics',
        component: Statistics,
        meta: { requiresAuth: true }
      }
    ] 
  },

  { 
    path: '/Auth',
    component: AuthLayout,
    children: [
      {
        path: '',
        name: 'Auth',
        component: Auth,
        meta: { guestOnly: true }
      }
    ]
  },

  {
    path: '/PasswordChange',
    component: AuthLayout,
    children: [
      {
        path: '',
        name: 'PasswordChange',
        component: PasswordChange,
        meta: { requiresAuth: true }
      }
    ]
  },

  {
    path: '/PasswordReset',
    component: AuthLayout,
    children: [
      {
        path: '',
        name: 'PasswordReset',
        component: PasswordReset,
        meta: { public: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('access_token')

  if (to.meta.public) return next()

  if (to.meta.requiresAuth && !token) {
    return next({ name: 'Auth' })
  }

  if (to.meta.guestOnly && token) {
    return next({ name: 'Dashboard' })
  }

  next()
})

export default router
